export default "__VITE_ASSET__C625$edD__"